var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diy-banner"},[_c('van-swipe',[_c('van-swipe-item',[_vm._v("1")]),_c('van-swipe-item',[_vm._v("2")]),_c('van-swipe-item',[_vm._v("3")]),_c('van-swipe-item',[_vm._v("4")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }